<!-- Planning Dialog -->
<app-planning-dialog
  [visible]="showPlanningDialog"
  [currentPlanning]="currentPlanning"
  (dialogClosed)="closePlanningDialog()"
  (execute)="executeCurrentPlanning()"
  [projectAdrPointsTotal]="projectAdrPointsTotal()">
</app-planning-dialog>

<!-- Loadunit Selection Dialog -->
<app-loadunit-selection-dialog
  [visible]="showChangeLoadunitDialog"
  [loadunitSelection]="loadunitSelection"
  [selectedLoadunitId]="selectedLoadunitId"
  [inAssignmentPlanningMode]="inAssignmentPlanningMode"
  (visibleChange)="showChangeLoadunitDialog = $event; !$event && closeChangeLoadunitDialog()"
  (selectedLoadunitIdChange)="selectedLoadunitId = $event"
  (loadunitSelected)="onLoadunitSelected()"
  (restRemains)="onRestRemains()">
</app-loadunit-selection-dialog>

<!-- PL Station Selection Dialog -->
<app-pl-station-selection-dialog
  [visible]="showPlStationSelectionDialog"
  [currentPlAssignment]="currentPlAssignment"
  [currentPlSubtableData]="currentPlSubtableData"
  [selectedPlStations]="selectedPlStations"
  (visibleChange)="showPlStationSelectionDialog = $event; !$event && closePlStationSelectionDialog()"
  (selectedPlStationsChange)="selectedPlStations = $event"
  (plStationSelected)="onPlStationSelected()">
</app-pl-station-selection-dialog>

<!-- Assignment Status Dialog -->
<app-assignment-status-dialog
  [visible]="showAssignmentStatusDialog"
  [assignmentCompleteData]="assignmentCompleteData"
  [assignmentCompleteOptions]="assignmentCompleteOptions"
  (visibleChange)="showAssignmentStatusDialog = $event"
  (assignmentCompleteDataChange)="assignmentCompleteData = $event"
  (sendStatusChange)="sendAssignmentStatusChange()"
  (hiding)="onPopUpHide()">
</app-assignment-status-dialog>

<div class="project-planner">
  <div class="planning-header">
    <div class="loadUnit-container">
      @for (lu of loadUnitSlots; track $index) {
        <div class="loadUnit">
          @if (lu) {
            <div class="loadUnit-header">
              <span class="loadUnit-name"> {{ lu.loadUnitContainer.name }} </span>
              <div>
                @if (lu.overload()) {
                  <i class="dx-icon-warning overload"></i>
                }

                @if (lu.cargoLoad.adrPointsTotal() > 0) {
                  <app-badge-variant
                    [shape]="Shape.Hexagon"
                    badge="none"
                    label="{{ lu.cargoLoad.adrPointsTotal() }}"
                    backgroundColor="#f97316"></app-badge-variant>
                }

                @if (lu.cargoLoad.isPrime()) {
                  <app-badge-variant
                    badge="none"
                    label="PL"
                    [shape]="Shape.Shield"
                    backgroundColor="var(--prime-logistics-color-1)"
                    [tooltip]="'ASSIGNMENT.INFOFILTER.PRIME_LOGISTIC' | translate" />
                }

                <dx-button
                  [id]="'truck'"
                  class="small-button"
                  icon="overflow"
                  [disabled]="!dispoPlanning()"
                  [hint]="'PROJECT_PLANNING.TOOLTIP.CHANGE_LOADUNIT' | translate"
                  (onClick)="changeLoadUnitForSlot($index)"></dx-button>
              </div>
            </div>
            <div class="loadUnit-utilization">
              <app-icon [kind]="'AssignmentDelivery'"></app-icon>
              <div>
                <span> {{ lu.cargoLoad.inTotal().volume | number: '1.1-1' }} m³ </span>
                <sub
                  >({{ (100 * lu.cargoLoad.inTotal().volume) / lu.loadUnitContainer.maxVolume | number: '1.1-1' }} %)
                </sub>
              </div>
              <div>
                <span>{{ lu.cargoLoad.inTotal().weight | number: '1.1-1' }} t </span>
                <sub
                  >({{ (100 * lu.cargoLoad.inTotal().weight) / lu.loadUnitContainer.maxLoad | number: '1.1-1' }} %)
                </sub>
              </div>
            </div>

            <div class="loadUnit-utilization">
              <app-icon [kind]="'AssignmentPickup'"></app-icon>
              <div>
                <span>{{ lu.cargoLoad.outTotal().volume | number: '1.1-1' }} m³ </span>
                <sub
                  >({{ (100 * lu.cargoLoad.outTotal().volume) / lu.loadUnitContainer.maxVolume | number: '1.1-1' }} %)
                </sub>
              </div>
              <div>
                <span>{{ lu.cargoLoad.outTotal().weight | number: '1.1-1' }} t </span>
                <sub
                  >({{ (100 * lu.cargoLoad.outTotal().weight) / lu.loadUnitContainer.maxLoad | number: '1.1-1' }} %)
                </sub>
              </div>
            </div>
          }
        </div>
      }
      @for (placeholder of placeholders; let i = $index; track i) {
        <div class="loadUnit">
          <div class="loadUnit-placeholder"></div>
        </div>
      }
    </div>
    <div class="expand-button-container">
      <dx-button class="small-button" icon="expand" (onClick)="expanded = !expanded"></dx-button>
    </div>
  </div>

  @if (allowEditPlanning()) {
    @if (!planningAllowed) {
      <dx-button
        class="planning-button"
        [text]="'BUTTONS.EDIT' | translate"
        [disabled]="editBusy.busy()"
        (onClick)="editProject()"></dx-button>
    } @else {
      <dx-button
        class="planning-button"
        [text]="'BUTTONS.FINISH_EDIT' | translate"
        [disabled]="editBusy.busy()"
        (onClick)="finishEdit()"></dx-button>
    }
  }

  <div>
    <dx-list
      id="project-planning-list"
      [dataSource]="displayProjectLoadunits()"
      class="planning-list"
      keyExpr="Id"
      [itemTemplate]="expanded ? 'list-item' : 'list-item-compact'"
      showScrollbar="onHover"
      (onContentReady)="onPlanningListContentReady($event)"
      (onItemClick)="loadAssignment($event)">
      <dxo-item-dragging
        [group]="'assignments'"
        [allowReordering]="isPlanningAllowed()"
        [onReorder]="updateProjectLoadunitOrder"
        [onAdd]="onAdd">
      </dxo-item-dragging>

      <div *dxTemplate="let projectLoadunit of 'list-item-compact'">
        <div class="projectLoadunit-card compact {{ projectLoadunit.Type }}">
          <div class="compact-col-10">
            <!-- TODO FDA: display indicator the lagerstatus TC1116 -->

            @if (isPrimeLogisticMain(projectLoadunit) || isPrimeLogisticStation(projectLoadunit)) {
              <span>
                <app-badge-variant
                  badge="none"
                  [label]="isPrimeLogisticMain(projectLoadunit) ? 'H' : 'S'"
                  [shape]="Shape.Shield"
                  [backgroundColor]="primeLogisticColorFor(projectLoadunit)"
                  [tooltip]="
                    (isPrimeLogisticMain(projectLoadunit)
                      ? 'PROJECT_PLANNING.PRIME_LOGISTIC.MAIN_TOOLTIP'
                      : 'PROJECT_PLANNING.PRIME_LOGISTIC.STATION_TOOLTIP'
                    ) | translate
                  "
              /></span>
            }

            {{ projectLoadunit.AssignmentNo }}
          </div>
          @if (isPrimeLogisticMain(projectLoadunit)) {
            <!-- keep the empty columns so the action buttons stay aligned -->
            <div class="compact-col-35"></div>
            <div class="compact-col-25"></div>
          } @else {
            <div class="compact-col-35">{{ projectLoadunit.ActionStreet }}</div>
            <div class="compact-col-25">{{ projectLoadunit.ActionZipCode }}, {{ projectLoadunit.ActionCity }}</div>
          }
          @if (!this.isLoading) {
            <div>
              <dx-button
                class="small-button"
                icon="remove"
                [hidden]="!isPlanningAllowed() || deletingRows.isBusy(projectLoadunit.Id)"
                [disabled]="deletingRows.anyBusy()"
                [hint]="'PROJECT_PLANNING.TOOLTIP.REMOVE' | translate"
                (onClick)="deleteProjectLoadUnit(projectLoadunit)"></dx-button>
              @if (deletingRows.isBusy(projectLoadunit.Id)) {
                <dx-load-indicator class="remove-button-indicator" [height]="20" [width]="20"></dx-load-indicator>
              }
              <dx-button
                class="small-button"
                icon="overflow"
                [hidden]="!dispoPlanning()"
                [disabled]="deletingRows.anyBusy()"
                [hint]="'PROJECT_PLANNING.TOOLTIP.EDIT_DISTRIBUTION' | translate"
                (onClick)="reOpenPlanningDialog(projectLoadunit)"></dx-button>
              @if (projectLoadunit.Completed) {
                <dx-button
                  class="small-button"
                  icon="revert"
                  [hidden]="!allowAssignmentStatusChange()"
                  [disabled]="rowBusy.isBusy(projectLoadunit.Id)"
                  [hint]="'PROJECT_PLANNING.TOOLTIP.REOPEN' | translate"
                  (onClick)="reopenAssignment(projectLoadunit)"></dx-button>
              } @else {
                <dx-button
                  class="small-button"
                  icon="check"
                  [hidden]="!allowAssignmentStatusChange()"
                  [disabled]="rowBusy.isBusy(projectLoadunit.Id)"
                  [hint]="'PROJECT_PLANNING.TOOLTIP.COMPLETE' | translate"
                  (onClick)="openAssignmentStatusDialog(projectLoadunit)"></dx-button>
              }
            </div>
          }
        </div>
      </div>

      <div *dxTemplate="let projectLoadunit of 'list-item'">
        <div class="projectLoadunit-card {{ projectLoadunit.Type }}">
          <div class="data-container">
            <div class="card-header-line">
              <div class="header" [class.header-warning]="projectLoadunit.LoadunitState === '1'">
                @if (hasHeaderIcon(projectLoadunit)) {
                  <div class="header-icons">
                    @if (isPrimeLogisticMain(projectLoadunit) || isPrimeLogisticStation(projectLoadunit)) {
                      <app-badge-variant
                        badge="none"
                        [label]="isPrimeLogisticMain(projectLoadunit) ? 'H' : 'S'"
                        [shape]="Shape.Shield"
                        [backgroundColor]="primeLogisticColorFor(projectLoadunit)"
                        [tooltip]="
                          (isPrimeLogisticMain(projectLoadunit)
                            ? 'PROJECT_PLANNING.PRIME_LOGISTIC.MAIN_TOOLTIP'
                            : 'PROJECT_PLANNING.PRIME_LOGISTIC.STATION_TOOLTIP'
                          ) | translate
                        " />
                    }
                    @if (projectLoadunit.LoadunitState === '1') {
                      <dx-button
                        class="header-icon small-button"
                        icon="edit"
                        stylingMode="text"
                        [hint]="'BUTTONS.STOCK_IN_PROGRESS' | translate"
                        [activeStateEnabled]="false"
                        [focusStateEnabled]="false"
                        [hoverStateEnabled]="false">
                      </dx-button>
                    }
                    @if (projectLoadunit.AdrPoints && projectLoadunit.AdrPoints > 0) {
                      <app-badge-variant
                        [shape]="Shape.Hexagon"
                        badge="none"
                        label="{{ projectLoadunit.AdrPoints }}"
                        backgroundColor="#f97316"></app-badge-variant>
                    }
                  </div>
                }

                <div>
                  {{ projectLoadunit.LoadunitName }}
                </div>
                @if (projectLoadunit.Statustext) {
                  <div class="status-text">{{ projectLoadunit.Statustext }}</div>
                }
                @if (projectLoadunit.Type === AssignmentType.AssignmentDelivery) {
                  @switch (projectLoadunit.MIAuftrag) {
                    @case (0) {
                      <!-- no badge -->
                    }
                    @case (1) {
                      <app-badge-variant
                        badge="warning"
                        label="MI"
                        [tooltip]="'ASSIGNMENT.MIAUFTRAGSTATUS.1' | translate" />
                    }
                    @case (2) {
                      <app-badge-variant
                        badge="check"
                        label="MI"
                        [tooltip]="'ASSIGNMENT.MIAUFTRAGSTATUS.2' | translate" />
                    }
                    @default {
                      <!-- optional: nothing / fallback -->
                    }
                  }
                }
                @if (
                  projectLoadunit.Type === AssignmentType.AssignmentPickup && projectLoadunit.NumMIProbSolutions > 0
                ) {
                  <app-badge-variant
                    badge="none"
                    label="{{ projectLoadunit.NumMIProbSolutions }}"
                    tooltip="{{ projectLoadunit.MIProbSolutionIDs }}" />
                }
                @for (note of notesFor(projectLoadunit); track note) {
                  <div class="note-row">
                    <span>{{ 'ASSIGNMENT_NOTE.' + note.note | translate: note.parameters }}</span>
                    @if (canBeConfirmed(note)) {
                      <dx-button
                        icon="check"
                        stylingMode="text"
                        class="small-button button-confirm"
                        [hint]="'BUTTONS.CONFIRM_NOTE' | translate"
                        [disabled]="rowBusy.isBusy(projectLoadunit.Id)"
                        (onClick)="$event.event?.stopPropagation(); confirmNote(note, projectLoadunit)">
                      </dx-button>
                    }
                  </div>
                }
                @if (projectLoadunit.T1) {
                  <div>
                    <div class="transportLabel">{{ projectLoadunit.T1 }}</div>
                  </div>
                }
                @if (projectLoadunit.T2) {
                  <div>
                    <div class="transportLabel">{{ projectLoadunit.T2 }}</div>
                  </div>
                }
              </div>
              @if (!this.isLoading) {
                <div>
                  <dx-check-box
                    class="small-checkbox"
                    [value]="projectLoadunit.Completed"
                    [disabled]="!allowAssignmentStatusChange() || rowBusy.isBusy(projectLoadunit.Id)"
                    [hint]="'PROJECT_PLANNING.TOOLTIP.COMPLETE' | translate"
                    (onValueChanged)="changeAssignmentState($event.value, projectLoadunit)">
                  </dx-check-box>
                  <!-- https://js.devexpress.com/Angular/Documentation/Guide/Themes_and_Styles/Icons/#Built-In_Icon_Library -->
                  <dx-button
                    class="small-button"
                    icon="codeblock"
                    [hidden]="!dispoPlanning()"
                    [hint]="'PROJECT_PLANNING.TOOLTIP.SWAP_LOADUNIT' | translate"
                    (onClick)="onSwapLoadForClick(projectLoadunit)"></dx-button>
                  <dx-button
                    class="small-button"
                    icon="overflow"
                    [hidden]="!dispoPlanning()"
                    [disabled]="deletingRows.anyBusy()"
                    [hint]="'PROJECT_PLANNING.TOOLTIP.EDIT_DISTRIBUTION' | translate"
                    (onClick)="reOpenPlanningDialog(projectLoadunit)"></dx-button>
                  <dx-button
                    class="small-button"
                    icon="remove"
                    [hidden]="!isPlanningAllowed() || deletingRows.isBusy(projectLoadunit.Id)"
                    [disabled]="deletingRows.anyBusy()"
                    [hint]="'PROJECT_PLANNING.TOOLTIP.REMOVE' | translate"
                    (onClick)="deleteProjectLoadUnit(projectLoadunit)"></dx-button>
                  @if (deletingRows.isBusy(projectLoadunit.Id)) {
                    <dx-load-indicator class="remove-button-indicator" [height]="20" [width]="20"></dx-load-indicator>
                  }
                </div>
              }
            </div>

            <div class="card-content">
              <div class="content-col-1">
                <div>{{ projectLoadunit.AssignmentNo }}</div>
                <div>{{ projectLoadunit.Customer }}</div>
                @if (!isPrimeLogisticMain(projectLoadunit)) {
                  <div>
                    <span>
                      {{ getEventDateDisplay(projectLoadunit) }}
                    </span>
                  </div>
                }
              </div>
              <div class="content-col-2">
                <!-- PL stations show neither volume/weight nor dispo date; the column stays to keep the card layout aligned -->
                @if (!isPrimeLogisticStation(projectLoadunit)) {
                  <div>
                    @if (
                      projectLoadunit.Type === 'AssignmentDelivery' || projectLoadunit.Type === 'ReturnRentalOrder'
                    ) {
                      <span>
                        {{ projectLoadunit.CurrentVolume | number: '1.2-2' }} m³ |
                        {{ projectLoadunit.CurrentWeight | number: '1.2-2' }} t
                      </span>
                    } @else {
                      <span>
                        {{ projectLoadunit.CurrentVolume_B | number: '1.2-2' }} m³ |
                        {{ projectLoadunit.CurrentWeight_B | number: '1.2-2' }} t
                      </span>
                    }
                  </div>
                }
                @if (!isPrimeLogisticMain(projectLoadunit) && !isPrimeLogisticStation(projectLoadunit)) {
                  <br />
                  <div>Dispo: {{ projectLoadunit.DispoDate | date: 'shortDate' }}</div>
                }
              </div>

              <div class="content-col-3">
                <!-- the address of a PL main assignment is not meaningful, its stations carry the real addresses -->
                @if (!isPrimeLogisticMain(projectLoadunit)) {
                  <div>{{ projectLoadunit.ActionAddress }}</div>
                  <div>{{ projectLoadunit.ActionStreet }}</div>
                  <div>
                    {{ projectLoadunit.ActionCountryCode }}-{{ projectLoadunit.ActionZipCode }}
                    {{ projectLoadunit.ActionCity }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </dx-list>
  </div>
  <app-loader [hide]="!isLoading" [displayAsOverlay]="true"></app-loader>
</div>
